import axios from '../config/axios';

export function apiGetCsv(subject, lang, filters) {
  return axios.get('export', {params: {subject: subject, lang: lang, format: 'csv', ...filters}});
}
